/**
 * Returns an array of numbers from `min` to `max`
 * @param {*} min
 * @param {*} max
 */
export const range = (min, max) => {
  const years = [...Array(1 + max - min).keys()];
  if (min !== 0) {
    return years.map((x) => x + min);
  }
  return years;
};

/**
 * Returns an array of years from `min.year` to `max.year`
 *
 * @param {*} param0 - Minimum Date
 * @param {*} param1 - Maximum Date
 */
export const getYears = (min, max) => range(min.year, max.year);

/**
 * Returns an array of months from min.month to max.month
 *
 * @param {*} param0 - Minimum Date
 * @param {*} param1 - Maximum Date
 * @param {*} param2 - Selected Date
 */
export const getMonths = (min = {}, max = {}, selected = {}) =>
  range(
    selected.year !== undefined && min.year === selected.year ? min.month : 0,
    selected.year !== undefined && max.year === selected.year ? max.month : 11
  );

/**
 * Gets the latest day of the month.
 *
 * @param {*} param0 - Selected Date
 */
export const getMaxDay = ({ month = 0, year = 1990 }) => {
  return (Date.UTC(year, month + 1, 1) - Date.UTC(year, month, 1)) / (24 * 60 * 60 * 1000);
};

/**
 * Returns an array of days for the given month, clipped by your
 *   min and max if applicable.
 *
 * @param {*} param0 - Minimum Date
 * @param {*} param1 - Maximum Date
 * @param {*} param2 - Selected Date
 */
export const getDays = (min = {}, max = {}, selected = {}) =>
  range(
    min.day !== undefined && min.year === selected.year && min.month === selected.month
      ? min.day
      : 1,
    max.day !== undefined && max.year === selected.year && max.month === selected.month
      ? max.day
      : getMaxDay(selected)
  );

/**
 * Gets the numerical values based on min/max/selected dates for the
 *   requested `field`
 *
 * @param {*} field
 * @param {*} minDate
 * @param {*} maxDate
 * @param {*} selectedDate
 */
export const getValues = (field, minDate, maxDate, selectedDate, sortYearAscending) => {
  switch (field) {
    case 'day':
      return getDays(minDate, maxDate, selectedDate);
    case 'month':
      return getMonths(minDate, maxDate, selectedDate);
    case 'year':
      return sortYearAscending ? getYears(minDate, maxDate) : getYears(minDate, maxDate).reverse();
    default:
      return [];
  }
};

const longMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const shortMonths = longMonths.map((x) => x.substr(0, 3).toUpperCase());

/**
 * Gets the text values for an input set for the given `field`
 *
 * @param {*} field
 * @param {*} short
 * @param {*} values
 */
export const getDisplays = (field, short, values) => {
  switch (field) {
    case 'month':
      return values.map((x) => (short ? shortMonths[x] : longMonths[x]));
    default:
      return values;
  }
};



// WEBPACK FOOTER //
// ./src/components/date-picker/date-helpers.js